import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58f1d71a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_form",
  ref: "createEventModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog mw-1200px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fs-3 el-icon el-dialog__close" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        fill: "currentColor",
        d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
      })
    ])
  ])
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body scroll-y bg-opacity-50 bg-light min-h-100px p-4" }
const _hoisted_8 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_modal_create_app_stepper",
  ref: "createAppRef"
}
const _hoisted_9 = { class: "d-flex justify-content-center justify-content-xl-start flex-row-auto py-5 w-100 w-xl-300px bg-white border" }
const _hoisted_10 = { class: "stepper-nav ps-lg-10" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "1")
], -1))
const _hoisted_13 = { class: "stepper-label" }
const _hoisted_14 = { class: "stepper-title" }
const _hoisted_15 = { class: "stepper-desc" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "2")
], -1))
const _hoisted_18 = { class: "stepper-label" }
const _hoisted_19 = { class: "stepper-title" }
const _hoisted_20 = { class: "stepper-desc" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "3")
], -1))
const _hoisted_23 = { class: "stepper-label" }
const _hoisted_24 = { class: "stepper-title" }
const _hoisted_25 = { class: "stepper-desc" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "4")
], -1))
const _hoisted_28 = { class: "stepper-label" }
const _hoisted_29 = { class: "stepper-title" }
const _hoisted_30 = { class: "stepper-desc" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "5")
], -1))
const _hoisted_33 = { class: "stepper-label" }
const _hoisted_34 = { class: "stepper-title" }
const _hoisted_35 = { class: "stepper-desc" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "6")
], -1))
const _hoisted_38 = { class: "stepper-label" }
const _hoisted_39 = { class: "stepper-title" }
const _hoisted_40 = { class: "stepper-desc" }
const _hoisted_41 = { class: "flex-row-fluid p-5 ms-xl-5 bg-white mh-700px min-h-150px scroll-y border" }
const _hoisted_42 = {
  class: "current min-h-300px",
  "data-kt-stepper-element": "content"
}
const _hoisted_43 = { class: "w-100" }
const _hoisted_44 = { class: "border-bottom mb-10 pb-5 text-gray-800" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-layers text-primary fs-2x" })
  ])
], -1))
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-lg-6 fv-row mb-4" }
const _hoisted_48 = { class: "required fw-bold fs-6 mb-2" }
const _hoisted_49 = { class: "col-lg-6 fv-row mb-4" }
const _hoisted_50 = { class: "required fw-bold fs-6 mb-2" }
const _hoisted_51 = { class: "d-flex flex-column fv-row w-40" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-lg-6 fv-row mb-4" }
const _hoisted_54 = { class: "required fw-bold fs-6 mb-2" }
const _hoisted_55 = { class: "position-relative d-flex align-items-center" }
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<span class=\"svg-icon svg-icon-2 position-absolute mx-4\" data-v-58f1d71a><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-58f1d71a><path opacity=\"0.3\" d=\"M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z\" fill=\"black\" data-v-58f1d71a></path><path d=\"M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z\" fill=\"black\" data-v-58f1d71a></path><path d=\"M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z\" fill=\"black\" data-v-58f1d71a></path></svg></span>", 1)
const _hoisted_57 = { class: "col-lg-6 fv-row mb-4" }
const _hoisted_58 = { class: "fw-bold fs-6 mb-2" }
const _hoisted_59 = { class: "position-relative d-flex align-items-center" }
const _hoisted_60 = /*#__PURE__*/_createStaticVNode("<span class=\"svg-icon svg-icon-2 position-absolute mx-4\" data-v-58f1d71a><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-58f1d71a><path opacity=\"0.3\" d=\"M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z\" fill=\"black\" data-v-58f1d71a></path><path d=\"M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z\" fill=\"black\" data-v-58f1d71a></path><path d=\"M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z\" fill=\"black\" data-v-58f1d71a></path></svg></span>", 1)
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-lg-6 fv-row mb-10" }
const _hoisted_63 = { class: "fw-bold fs-6 mb-2" }
const _hoisted_64 = { class: "d-flex flex-column fv-row w-100" }
const _hoisted_65 = { class: "col-lg-6 fv-row mt-10" }
const _hoisted_66 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_67 = {
  class: "form-check-label fw-bold fs-6",
  for: "flexCheckDefault"
}
const _hoisted_68 = { "data-kt-stepper-element": "content" }
const _hoisted_69 = { class: "w-100 min-h-300px" }
const _hoisted_70 = { class: "border-bottom pb-5 text-gray-800 ps-5" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-diagram-3 fs-3 text-primary" })
  ])
], -1))
const _hoisted_72 = { class: "card mb-5 pt-5 border border-info border-dashed" }
const _hoisted_73 = { class: "card-header ps-5 border-0" }
const _hoisted_74 = { class: "d-flex align-items-center position-relative" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_78 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_79 = { class: "visually-hidden" }
const _hoisted_80 = { class: "card-body ps-5 pt-0 mh-400px scroll-y" }
const _hoisted_81 = { class: "table-responsive" }
const _hoisted_82 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_83 = { class: "fw-bold text-muted" }
const _hoisted_84 = { class: "w-50px" }
const _hoisted_85 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_86 = ["checked"]
const _hoisted_87 = { class: "min-w-150px text-uppercase" }
const _hoisted_88 = { class: "min-w-140px text-uppercase" }
const _hoisted_89 = { class: "min-w-140px text-uppercase" }
const _hoisted_90 = { class: "text-gray-600" }
const _hoisted_91 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_92 = ["value"]
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { class: "d-flex align-items-center" }
const _hoisted_95 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_96 = { class: "fs-base" }
const _hoisted_97 = { class: "fs-base" }
const _hoisted_98 = { class: "fs-base" }
const _hoisted_99 = { "data-kt-stepper-element": "content" }
const _hoisted_100 = { class: "w-100 list-boxes min-h-300px mh-600px" }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { class: "border-bottom mb-10 pb-5 text-gray-800" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-list-stars fs-3 text-primary" })
  ])
], -1))
const _hoisted_104 = { class: "row" }
const _hoisted_105 = { class: "dual-list list-left col-sm-6" }
const _hoisted_106 = { class: "well text-right" }
const _hoisted_107 = { class: "d-flex align-items-center mb-2" }
const _hoisted_108 = { class: "flex-grow-1 me-2" }
const _hoisted_109 = { class: "col-md-12 list-group my-3 p-4" }
const _hoisted_110 = { class: "d-flex align-items-center position-relative mb-4" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = ["placeholder"]
const _hoisted_114 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid margin-left-select margin-bottom-select"
}
const _hoisted_115 = ["checked"]
const _hoisted_116 = { class: "fw-bold text-gray-800 fs-6 margin-left-select" }
const _hoisted_117 = {
  key: 1,
  class: "d-flex justify-content-center fw-bold text-muted"
}
const _hoisted_118 = { class: "d-flex align-items-center bg-light-info rounded p-4 mb-3 cursor-move" }
const _hoisted_119 = { class: "form-check form-check-custom me-5" }
const _hoisted_120 = ["value"]
const _hoisted_121 = ["onClick"]
const _hoisted_122 = ["onClick"]
const _hoisted_123 = { class: "fw-bold text-gray-800 fs-6" }
const _hoisted_124 = { class: "list-arrows" }
const _hoisted_125 = ["onClick"]
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-eye fs-6" }, null, -1))
const _hoisted_127 = [
  _hoisted_126
]
const _hoisted_128 = { class: "dual-list list-right col-md-6" }
const _hoisted_129 = { class: "well" }
const _hoisted_130 = { class: "d-flex align-items-center mb-2" }
const _hoisted_131 = { class: "flex-grow-1 me-2" }
const _hoisted_132 = { class: "col-md-12 list-group my-3 p-4" }
const _hoisted_133 = { class: "d-flex align-items-center position-relative mb-4" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_135 = [
  _hoisted_134
]
const _hoisted_136 = ["placeholder"]
const _hoisted_137 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid margin-left-select margin-bottom-select"
}
const _hoisted_138 = ["checked"]
const _hoisted_139 = { class: "fw-bold text-gray-800 fs-6 margin-left-select" }
const _hoisted_140 = {
  key: 1,
  class: "d-flex justify-content-center fw-bold text-muted"
}
const _hoisted_141 = { class: "d-flex align-items-center bg-light-success rounded p-4 mb-3 cursor-move" }
const _hoisted_142 = { class: "form-check form-check-custom me-5" }
const _hoisted_143 = ["value"]
const _hoisted_144 = ["onClick"]
const _hoisted_145 = ["onClick"]
const _hoisted_146 = { class: "fw-bold text-gray-800 fs-6" }
const _hoisted_147 = { class: "list-arrows min-w-80px" }
const _hoisted_148 = ["onClick"]
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bi bi-link fs-6" }, null, -1))
const _hoisted_150 = [
  _hoisted_149
]
const _hoisted_151 = ["onClick"]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-eye fs-6" }, null, -1))
const _hoisted_153 = [
  _hoisted_152
]
const _hoisted_154 = { "data-kt-stepper-element": "content" }
const _hoisted_155 = { class: "w-100 min-h-300px" }
const _hoisted_156 = { class: "accordion-item mb-2 border-0" }
const _hoisted_157 = {
  class: "accordion-header border-bottom",
  id: "accordHead1"
}
const _hoisted_158 = {
  class: "accordion-button fs-4 fw-bold collapsed ps-2",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#accordBody1",
  "aria-expanded": "true",
  "aria-controls": "accordBody1"
}
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "las la-users-cog fs-3 text-primary" })
  ])
], -1))
const _hoisted_160 = {
  id: "accordBody1",
  class: "accordion-collapse collapse",
  "aria-labelledby": "accordHead1"
}
const _hoisted_161 = { class: "accordion-body px-0 py-2" }
const _hoisted_162 = { class: "card mb-5 py-5 border border-info border-dashed" }
const _hoisted_163 = { class: "card-header border-0 px-5" }
const _hoisted_164 = { class: "d-flex align-items-center position-relative" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_166 = [
  _hoisted_165
]
const _hoisted_167 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_168 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_169 = { class: "visually-hidden" }
const _hoisted_170 = { class: "card-body pt-0 px-5 mh-300px scroll-y" }
const _hoisted_171 = { class: "table-responsive" }
const _hoisted_172 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_173 = { class: "fw-bold text-muted" }
const _hoisted_174 = { class: "w-50px" }
const _hoisted_175 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_176 = ["checked"]
const _hoisted_177 = { class: "min-w-150px text-uppercase" }
const _hoisted_178 = { class: "min-w-140px text-uppercase" }
const _hoisted_179 = { class: "text-gray-600" }
const _hoisted_180 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_181 = ["id", "value"]
const _hoisted_182 = { class: "d-flex align-items-center" }
const _hoisted_183 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_184 = { class: "fs-base" }
const _hoisted_185 = { class: "fs-base" }
const _hoisted_186 = { class: "accordion-item mb-2 border-0" }
const _hoisted_187 = {
  class: "accordion-header border-bottom",
  id: "accordHead2"
}
const _hoisted_188 = {
  class: "accordion-button fs-4 fw-bold collapsed ps-2",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#accordBody2",
  "aria-expanded": "false",
  "aria-controls": "accordBody2"
}
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people fs-3 text-primary" })
  ])
], -1))
const _hoisted_190 = {
  id: "accordBody2",
  class: "accordion-collapse collapse",
  "aria-labelledby": "accordHead2"
}
const _hoisted_191 = { class: "accordion-body px-0 py-2" }
const _hoisted_192 = { class: "card mb-5 py-5 border border-info border-dashed" }
const _hoisted_193 = { class: "card-header border-0 px-5" }
const _hoisted_194 = { class: "d-flex align-items-center position-relative" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_196 = [
  _hoisted_195
]
const _hoisted_197 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_198 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_199 = { class: "visually-hidden" }
const _hoisted_200 = { class: "card-body pt-0 px-5 mh-300px scroll-y" }
const _hoisted_201 = { class: "table-responsive" }
const _hoisted_202 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_203 = { class: "fw-bold text-muted" }
const _hoisted_204 = { class: "w-50px" }
const _hoisted_205 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_206 = ["checked"]
const _hoisted_207 = { class: "min-w-150px text-uppercase" }
const _hoisted_208 = { class: "min-w-150px text-uppercase" }
const _hoisted_209 = { class: "min-w-140px text-uppercase" }
const _hoisted_210 = { class: "text-gray-600" }
const _hoisted_211 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_212 = ["value"]
const _hoisted_213 = { class: "d-flex align-items-center" }
const _hoisted_214 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_215 = { class: "fs-base" }
const _hoisted_216 = { class: "fs-base" }
const _hoisted_217 = { class: "fs-base" }
const _hoisted_218 = { "data-kt-stepper-element": "content" }
const _hoisted_219 = { class: "w-100 min-h-300px" }
const _hoisted_220 = { class: "border-bottom pb-5 text-gray-800" }
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "las la-business-time fs-3 text-primary" })
  ])
], -1))
const _hoisted_222 = { class: "card mb-5 pt-5 border border-info border-dashed" }
const _hoisted_223 = { class: "card-header ps-5 border-0" }
const _hoisted_224 = { class: "d-flex align-items-center position-relative" }
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_226 = [
  _hoisted_225
]
const _hoisted_227 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5"
}
const _hoisted_228 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_229 = { class: "visually-hidden" }
const _hoisted_230 = { class: "card-body ps-5 pt-3 mh-400px scroll-y" }
const _hoisted_231 = { class: "table-responsive" }
const _hoisted_232 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_233 = { class: "fw-bold text-muted" }
const _hoisted_234 = { class: "w-50px" }
const _hoisted_235 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_236 = ["checked"]
const _hoisted_237 = { class: "min-w-150px text-uppercase" }
const _hoisted_238 = { class: "min-w-140px text-uppercase" }
const _hoisted_239 = { class: "text-gray-600" }
const _hoisted_240 = { key: 0 }
const _hoisted_241 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_242 = ["value", "id"]
const _hoisted_243 = { key: 1 }
const _hoisted_244 = { class: "d-flex align-items-center" }
const _hoisted_245 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_246 = { class: "fs-base" }
const _hoisted_247 = { key: 2 }
const _hoisted_248 = { class: "fs-base" }
const _hoisted_249 = { "data-kt-stepper-element": "content" }
const _hoisted_250 = { class: "w-100 min-h-300px mh-600px" }
const _hoisted_251 = { class: "border-bottom mb-5 pb-5 text-gray-800" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-35px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-view-list fs-3 text-primary" })
  ])
], -1))
const _hoisted_253 = { class: "card mb-5" }
const _hoisted_254 = { class: "card-body p-0 min-h-450px scroll-y" }
const _hoisted_255 = { class: "table-responsive" }
const _hoisted_256 = { class: "table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px" }
const _hoisted_257 = { class: "fw-bold text-gray-600" }
const _hoisted_258 = { class: "text-muted ps-5" }
const _hoisted_259 = { class: "d-flex align-items-center" }
const _hoisted_260 = { class: "fw-bolder text-end" }
const _hoisted_261 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_262 = { class: "text-muted ps-5" }
const _hoisted_263 = { class: "d-flex align-items-center" }
const _hoisted_264 = { class: "fw-bolder text-end" }
const _hoisted_265 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_266 = { class: "text-muted ps-5" }
const _hoisted_267 = { class: "d-flex align-items-center" }
const _hoisted_268 = { class: "fw-bolder text-end" }
const _hoisted_269 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_270 = { key: 0 }
const _hoisted_271 = { class: "text-muted ps-5" }
const _hoisted_272 = { class: "d-flex align-items-center" }
const _hoisted_273 = { class: "fw-bolder text-start" }
const _hoisted_274 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_275 = { class: "me-4" }
const _hoisted_276 = {
  key: 0,
  class: "fas fa-times fs-4 text-danger"
}
const _hoisted_277 = {
  key: 1,
  class: "fas fa-check fs-4 text-primary"
}
const _hoisted_278 = { class: "text-muted ps-5" }
const _hoisted_279 = { class: "d-flex align-items-center" }
const _hoisted_280 = { class: "fw-bolder text-end" }
const _hoisted_281 = { class: "d-flex align-items-center justify-content-start" }
const _hoisted_282 = { key: 0 }
const _hoisted_283 = {
  class: "text-muted",
  colspan: "2"
}
const _hoisted_284 = { class: "accordion-item" }
const _hoisted_285 = {
  class: "accordion-header",
  id: "kt_accordion_1_header_3"
}
const _hoisted_286 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_body_3",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_1_body_3"
}
const _hoisted_287 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-diagram-3 fs-3 text-primary" })
  ])
], -1))
const _hoisted_288 = {
  id: "kt_accordion_1_body_3",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_1_header_3",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_289 = { class: "accordion-body" }
const _hoisted_290 = { class: "table-responsive" }
const _hoisted_291 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_292 = { class: "fw-bold text-muted" }
const _hoisted_293 = { class: "min-w-150px text-uppercase" }
const _hoisted_294 = { class: "min-w-140px text-uppercase" }
const _hoisted_295 = { class: "min-w-140px text-end text-uppercase" }
const _hoisted_296 = { class: "text-end" }
const _hoisted_297 = { key: 1 }
const _hoisted_298 = {
  class: "text-muted",
  colspan: "2"
}
const _hoisted_299 = { class: "accordion-item" }
const _hoisted_300 = {
  class: "accordion-header",
  id: "kt_accordion_2_header_3"
}
const _hoisted_301 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_2_body_3",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_2_body_3"
}
const _hoisted_302 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "las la-users-cog fs-3 text-primary" })
  ])
], -1))
const _hoisted_303 = {
  id: "kt_accordion_2_body_3",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_2_header_3",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_304 = { class: "accordion-body" }
const _hoisted_305 = { class: "table-responsive" }
const _hoisted_306 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_307 = { class: "fw-bold text-muted" }
const _hoisted_308 = { class: "min-w-150px text-uppercase" }
const _hoisted_309 = { class: "min-w-140px text-uppercase" }
const _hoisted_310 = { key: 2 }
const _hoisted_311 = {
  class: "text-muted",
  colspan: "2"
}
const _hoisted_312 = { class: "accordion-item" }
const _hoisted_313 = {
  class: "accordion-header",
  id: "kt_accordion_3_header_3"
}
const _hoisted_314 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_3_body_3",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_3_body_3"
}
const _hoisted_315 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people fs-3 text-primary" })
  ])
], -1))
const _hoisted_316 = {
  id: "kt_accordion_3_body_3",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_3_header_3",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_317 = { class: "accordion-body" }
const _hoisted_318 = { class: "table-responsive" }
const _hoisted_319 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_320 = { class: "fw-bold text-muted" }
const _hoisted_321 = { class: "min-w-150px text-uppercase" }
const _hoisted_322 = { class: "min-w-150px text-uppercase" }
const _hoisted_323 = { class: "min-w-150px text-uppercase" }
const _hoisted_324 = { key: 3 }
const _hoisted_325 = {
  class: "text-muted",
  colspan: "2"
}
const _hoisted_326 = { class: "accordion-item" }
const _hoisted_327 = {
  class: "accordion-header",
  id: "kt_accordion_4_header_3"
}
const _hoisted_328 = {
  class: "accordion-button fs-5 fw-bold text-black-50 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_4_body_3",
  "aria-expanded": "false",
  "aria-controls": "kt_accordion_4_body_3"
}
const _hoisted_329 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle symbol-30px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label border border-primary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "las la-business-time fs-3 text-primary" })
  ])
], -1))
const _hoisted_330 = {
  id: "kt_accordion_4_body_3",
  class: "accordion-collapse collapse",
  "aria-labelledby": "kt_accordion_4_header_3",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_331 = { class: "accordion-body" }
const _hoisted_332 = { class: "table-responsive" }
const _hoisted_333 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_334 = { class: "fw-bold text-muted" }
const _hoisted_335 = { class: "min-w-150px text-uppercase" }
const _hoisted_336 = { class: "min-w-140px text-end text-uppercase" }
const _hoisted_337 = { class: "text-end" }
const _hoisted_338 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_339 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_340 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_341 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_342 = /*#__PURE__*/_createTextVNode(" Close ")
const _hoisted_343 = { class: "indicator-label" }
const _hoisted_344 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_345 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_346 = {
  key: 3,
  type: "submit",
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
}
const _hoisted_347 = /*#__PURE__*/_createTextVNode(" Continue ")
const _hoisted_348 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_VZMultiSelect = _resolveComponent("VZMultiSelect")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_FormSectionModal = _resolveComponent("FormSectionModal")!
  const _component_AddEditModal = _resolveComponent("AddEditModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "form",
        novalidate: "novalidate",
        id: "kt_modal_create_app_form",
        onSubmit: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("h2", null, _toDisplayString(_ctx.t("pages.form.addForm")), 513), [
              [_vShow, !_ctx.edit_form]
            ]),
            _withDirectives(_createElementVNode("h2", null, _toDisplayString(_ctx.t("pages.form.editForm")), 513), [
              [_vShow, _ctx.edit_form]
            ]),
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["stop"]))
            }, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "stepper-item current",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(1)), ["stop"]))
                  }, [
                    _hoisted_11,
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.t("pages.form.formDetail")), 1),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t("pages.form.detailAndType")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "stepper-item",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(2)), ["stop"]))
                  }, [
                    _hoisted_16,
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("h3", _hoisted_19, _toDisplayString(_ctx.t("pages.form.sites")), 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("pages.form.selectSite")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "stepper-item",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(3)), ["stop"]))
                  }, [
                    _hoisted_21,
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.t("pages.form.sections")), 1),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.t("pages.form.selectSection")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "stepper-item",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(4)), ["stop"]))
                  }, [
                    _hoisted_26,
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("h3", _hoisted_29, _toDisplayString(_ctx.t("pages.form.roleUsers")), 1),
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.t("pages.form.providedDetails")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "stepper-item",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(5)), ["stop"]))
                  }, [
                    _hoisted_31,
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.t("pages.form.events")), 1),
                      _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.t("pages.form.providedDetails")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "stepper-item",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(6)), ["stop"]))
                  }, [
                    _hoisted_36,
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("h3", _hoisted_39, _toDisplayString(_ctx.t("common.preview")), 1),
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.t("common.reviewSubmit")), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("h3", _hoisted_44, [
                      _hoisted_45,
                      _createTextVNode(" " + _toDisplayString(_ctx.t("pages.form.formDetail")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.t("common.name")), 1),
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control",
                          name: "formName",
                          placeholder: "",
                          modelValue: _ctx.post_form_data.name,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.post_form_data.name) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "formName"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t("pages.form.category")), 1),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_Field, {
                            name: "categoryCode",
                            modelValue: 
                              _ctx.post_form_data.formCategoryGlobalModel
                                .categoryCode
                            ,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((
                              _ctx.post_form_data.formCategoryGlobalModel
                                .categoryCode
                            ) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_VZMultiSelect, _mergeProps({
                                modelValue: 
                                _ctx.post_form_data.formCategoryGlobalModel
                                  .categoryCode
                              ,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((
                                _ctx.post_form_data.formCategoryGlobalModel
                                  .categoryCode
                              ) = $event))
                              }, field, {
                                name: "categoryCode",
                                maxSelectedItems: "20",
                                element: {
                                options: _ctx.formCategories.map(
                                  ({ text: label, value }) => ({
                                    label,
                                    value,
                                  })
                                ),
                                multiSelect: true,
                                placeholder: 'Please select category',
                              }
                              }), null, 16, ["modelValue", "element"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "categoryCode"
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.t("common.startDate")), 1),
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createVNode(_component_Field, {
                            name: "startDate",
                            modelValue: _ctx.post_form_data.startDate,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.post_form_data.startDate) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Datepicker, _mergeProps({
                                modelValue: _ctx.post_form_data.startDate,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.post_form_data.startDate) = $event)),
                                enableTimePicker: false,
                                placeholder: "Select Date",
                                format: _ctx.displayDate,
                                autoApply: true,
                                "model-type": "yyyy-MM-dd"
                              }, field, {
                                teleport: "body",
                                class: "w-100"
                              }), null, 16, ["modelValue", "format"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "startDate"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.t("common.endDate")), 1),
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _createVNode(_component_Field, {
                            name: "endDate",
                            modelValue: _ctx.post_form_data.endDate,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.post_form_data.endDate) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Datepicker, _mergeProps({
                                modelValue: _ctx.post_form_data.endDate,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.post_form_data.endDate) = $event)),
                                enableTimePicker: false,
                                placeholder: "Select Date",
                                format: _ctx.displayDate,
                                autoApply: true,
                                "model-type": "yyyy-MM-dd"
                              }, field, {
                                "min-date": _ctx.minEndDate,
                                teleport: "body",
                                class: "w-100"
                              }), null, 16, ["modelValue", "format", "min-date"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "endDate"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.t("common.status")), 1),
                        _createElementVNode("div", _hoisted_64, [
                          _createVNode(_component_Field, {
                            name: "status",
                            modelValue: _ctx.post_form_data.status,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.post_form_data.status) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_el_input, _mergeProps(field, {
                                modelValue: _ctx.post_form_data.status,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.post_form_data.status) = $event)),
                                disabled: ""
                              }), null, 16, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "status"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            value: "locationRestrict",
                            id: "flexCheckDefault",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.first_screen_booleans) = $event)),
                            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.checkLocationBoolean($event)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.first_screen_booleans]
                          ]),
                          _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.t("pages.user.form.locationRestrict")), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("h3", _hoisted_70, [
                      _hoisted_71,
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.sites")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("span", {
                            class: "svg-icon svg-icon-1 position-absolute ms-3",
                            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.getAllFormSites && _ctx.getAllFormSites(...args)))
                          }, _hoisted_76),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "data-kt-user-table-filter": "search",
                            class: "form-control w-md-350px ps-13",
                            placeholder: "Search here...",
                            onKeyup: _cache[19] || (_cache[19] = 
                              () => {
                                if (
                                  _ctx.searchTermSites.length == 0 ||
                                  _ctx.searchTermSites.length >= 3
                                )
                                  _ctx.getAllFormSites();
                              }
                            ),
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.searchTermSites) = $event))
                          }, null, 544), [
                            [_vModelText, _ctx.searchTermSites]
                          ])
                        ])
                      ]),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.t("common.loading")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("table", _hoisted_82, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_83, [
                                _createElementVNode("th", _hoisted_84, [
                                  _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      id: "checkAllSites",
                                      checked: 
                                        _ctx.post_form_data.formSiteGlobalModel
                                          .siteIds.length > 0 &&
                                        _ctx.allFormSites.length > 0 &&
                                        _ctx.post_form_data.formSiteGlobalModel
                                          .siteIds.length ===
                                          _ctx.allFormSites.length
                                      ,
                                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.selectAllSites($event)))
                                    }, null, 8, _hoisted_86)
                                  ])
                                ]),
                                _createElementVNode("th", _hoisted_87, _toDisplayString(_ctx.t("common.siteName")), 1),
                                _createElementVNode("th", _hoisted_88, _toDisplayString(_ctx.t("pages.site.siteNumber")), 1),
                                _createElementVNode("th", _hoisted_89, _toDisplayString(_ctx.t("common.siteAddress")), 1)
                              ])
                            ]),
                            _createElementVNode("tbody", _hoisted_90, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFormSites, (singleSite, s) => {
                                return (_openBlock(), _createElementBlock("tr", { key: s }, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_91, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        class: "form-check-input",
                                        value: singleSite.webId,
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((
                                          _ctx.post_form_data.formSiteGlobalModel
                                            .siteIds
                                        ) = $event))
                                      }, null, 8, _hoisted_92), [
                                        [_vModelCheckbox, 
                                          _ctx.post_form_data.formSiteGlobalModel
                                            .siteIds
                                        ]
                                      ])
                                    ])
                                  ]),
                                  (singleSite.status == 'ACTIVE')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_93, [
                                        _createElementVNode("div", _hoisted_94, [
                                          _createElementVNode("div", _hoisted_95, [
                                            _createElementVNode("span", _hoisted_96, _toDisplayString(singleSite.name), 1)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_97, _toDisplayString(singleSite.code), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_98, _toDisplayString(singleSite?.addressModel.city +
                                      ", " +
                                      singleSite?.addressModel.state +
                                      ", " +
                                      singleSite?.addressModel.country), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("h3", _hoisted_102, [
                        _hoisted_103,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("pages.form.sections")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _createElementVNode("div", _hoisted_107, [
                            _createElementVNode("div", _hoisted_108, [
                              _createElementVNode("h5", null, _toDisplayString(_ctx.t("pages.form.availableSections")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("div", _hoisted_110, [
                              _createElementVNode("span", {
                                class: "svg-icon svg-icon-1 position-absolute ms-3",
                                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.getAllFormSections && _ctx.getAllFormSections(...args)))
                              }, _hoisted_112),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "data-kt-user-table-filter": "search",
                                class: "form-control ps-13 mb-2 mb-sm-0",
                                placeholder: _ctx.t('common.search'),
                                onKeyup: _cache[24] || (_cache[24] = 
                                  () => {
                                    if (
                                      _ctx.searchTermSections.length == 0 ||
                                      _ctx.searchTermSections.length >= 3
                                    )
                                      _ctx.getAllFormSections();
                                  }
                                ),
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.searchTermSections) = $event))
                              }, null, 40, _hoisted_113), [
                                [_vModelText, _ctx.searchTermSections]
                              ])
                            ]),
                            (_ctx.list2?.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    checked: 
                                  _ctx.sectionMoveSelected.length > 0 &&
                                  _ctx.list2.length > 0 &&
                                  _ctx.sectionMoveSelected.length === _ctx.list2.length
                                ,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.moveAllForward) = $event)),
                                    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.moveAllForwardClicked && _ctx.moveAllForwardClicked(...args)))
                                  }, null, 8, _hoisted_115), [
                                    [_vModelCheckbox, _ctx.moveAllForward]
                                  ]),
                                  _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.t("common.selectAll")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(_ctx.t("common.noData")), 1)),
                            _createVNode(_component_draggable, {
                              class: "dragArea",
                              list: _ctx.list2,
                              group: "people",
                              "item-key": "id",
                              onChange: _ctx.changeAvailableSection
                            }, {
                              item: _withCtx(({ element }) => [
                                _createElementVNode("div", _hoisted_118, [
                                  _createElementVNode("div", _hoisted_119, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      value: element.webId,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.sectionMoveSelected) = $event)),
                                      onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 8, _hoisted_120), [
                                      [_vModelCheckbox, _ctx.sectionMoveSelected]
                                    ])
                                  ]),
                                  _createElementVNode("i", {
                                    class: "bi bi-list-stars text-primary fs-2 me-3 mt-1",
                                    onClick: ($event: any) => (_ctx.addToSelectionMove(element.webId))
                                  }, null, 8, _hoisted_121),
                                  _createElementVNode("div", {
                                    class: "flex-grow-1 me-2",
                                    onClick: ($event: any) => (_ctx.addToSelectionMove(element.webId))
                                  }, [
                                    _createElementVNode("span", _hoisted_123, _toDisplayString(element.name), 1)
                                  ], 8, _hoisted_122),
                                  _createElementVNode("span", _hoisted_124, [
                                    _createElementVNode("a", {
                                      class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                                      onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(element)), ["stop"])
                                    }, _hoisted_127, 8, _hoisted_125)
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["list", "onChange"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_128, [
                        _createElementVNode("div", _hoisted_129, [
                          _createElementVNode("div", _hoisted_130, [
                            _createElementVNode("div", _hoisted_131, [
                              _createElementVNode("h5", null, _toDisplayString(_ctx.t("pages.form.selectedSections")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_132, [
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("span", {
                                class: "svg-icon svg-icon-1 position-absolute ms-3",
                                onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.searchSectionFilters && _ctx.searchSectionFilters(...args)))
                              }, _hoisted_135),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "data-kt-user-table-filter": "search",
                                class: "form-control ps-13 mb-2 mb-sm-0",
                                placeholder: _ctx.t('common.search'),
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.searchSections) = $event)),
                                onKeyup: _cache[32] || (_cache[32] = 
                                  () => {
                                    if (
                                      _ctx.searchSections.length == 0 ||
                                      _ctx.searchSections.length >= 3
                                    )
                                      _ctx.searchSectionFilters();
                                  }
                                )
                              }, null, 40, _hoisted_136), [
                                [_vModelText, _ctx.searchSections]
                              ])
                            ]),
                            (_ctx.list1?.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    checked: 
                                  _ctx.sectionBackSelected.length > 0 &&
                                  _ctx.list1.length > 0 &&
                                  _ctx.sectionBackSelected.length === _ctx.list1.length
                                ,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.moveAllBackward) = $event)),
                                    onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.moveAllBackwardClicked && _ctx.moveAllBackwardClicked(...args)))
                                  }, null, 8, _hoisted_138), [
                                    [_vModelCheckbox, _ctx.moveAllBackward]
                                  ]),
                                  _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.t("common.selectAll")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_140, _toDisplayString(_ctx.t("common.noData")), 1)),
                            _createVNode(_component_draggable, {
                              class: "dragArea",
                              list: _ctx.list1,
                              group: "people",
                              "item-key": "id",
                              onChange: _ctx.moveBack
                            }, {
                              item: _withCtx(({ element }) => [
                                _createElementVNode("div", _hoisted_141, [
                                  _createElementVNode("div", _hoisted_142, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      value: element.webId,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.sectionBackSelected) = $event)),
                                      onClick: _cache[36] || (_cache[36] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 8, _hoisted_143), [
                                      [_vModelCheckbox, _ctx.sectionBackSelected]
                                    ])
                                  ]),
                                  _createElementVNode("i", {
                                    class: "bi bi-list-stars text-primary fs-2 me-3 mt-1",
                                    onClick: ($event: any) => (_ctx.addBackSelectionMove(element.webId))
                                  }, null, 8, _hoisted_144),
                                  _createElementVNode("div", {
                                    class: "flex-grow-1 me-2",
                                    onClick: ($event: any) => (_ctx.addBackSelectionMove(element.webId))
                                  }, [
                                    _createElementVNode("span", _hoisted_146, _toDisplayString(element.sectionName ?? element.name) + "[" + _toDisplayString(element?.locationName) + "] ", 1)
                                  ], 8, _hoisted_145),
                                  _createElementVNode("span", _hoisted_147, [
                                    _createVNode(_component_el_tooltip, {
                                      class: "box-item",
                                      effect: "dark",
                                      content: "Assign Location",
                                      placement: "top"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                                          onClick: _withModifiers(($event: any) => (_ctx.openLocationModal(element)), ["stop"])
                                        }, _hoisted_150, 8, _hoisted_148)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("a", {
                                      class: "btn btn-icon btn-light-primary w-30px h-30px bg-transparent",
                                      onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(element)), ["stop"])
                                    }, _hoisted_153, 8, _hoisted_151)
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["list", "onChange"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("div", _hoisted_156, [
                      _createElementVNode("h3", _hoisted_157, [
                        _createElementVNode("button", _hoisted_158, [
                          _hoisted_159,
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.roles")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_160, [
                        _createElementVNode("div", _hoisted_161, [
                          _createElementVNode("div", _hoisted_162, [
                            _createElementVNode("div", _hoisted_163, [
                              _createElementVNode("div", _hoisted_164, [
                                _createElementVNode("span", {
                                  class: "svg-icon svg-icon-1 position-absolute ms-3",
                                  onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.filterFormRoles && _ctx.filterFormRoles(...args)))
                                }, _hoisted_166),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "data-kt-user-table-filter": "search",
                                  class: "form-control w-md-350px ps-13",
                                  placeholder: "Search here...",
                                  onKeyup: _cache[38] || (_cache[38] = 
                                    () => {
                                      if (
                                        _ctx.searchTermRoles.length == 0 ||
                                        _ctx.searchTermRoles.length >= 3
                                      )
                                        _ctx.filterFormRoles();
                                    }
                                  ),
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.searchTermRoles) = $event))
                                }, null, 544), [
                                  [_vModelText, _ctx.searchTermRoles]
                                ])
                              ])
                            ]),
                            (_ctx.loading)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                  _createElementVNode("div", _hoisted_168, [
                                    _createElementVNode("span", _hoisted_169, _toDisplayString(_ctx.t("common.loading")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_170, [
                              _createElementVNode("div", _hoisted_171, [
                                _createElementVNode("table", _hoisted_172, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", _hoisted_173, [
                                      _createElementVNode("th", _hoisted_174, [
                                        _createElementVNode("div", _hoisted_175, [
                                          _createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "checkAll",
                                            checked: 
                                              _ctx.post_form_data.formRoleGlobalModel
                                                .roleIds.length > 0 &&
                                              _ctx.allFormRolesFilter.length > 0 &&
                                              _ctx.post_form_data.formRoleGlobalModel
                                                .roleIds.length ===
                                                _ctx.allFormRolesFilter.length
                                            ,
                                            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.selectAll($event)))
                                          }, null, 8, _hoisted_176)
                                        ])
                                      ]),
                                      _createElementVNode("th", _hoisted_177, _toDisplayString(_ctx.t("pages.user.roleName")), 1),
                                      _createElementVNode("th", _hoisted_178, _toDisplayString(_ctx.t("common.siteName")), 1)
                                    ])
                                  ]),
                                  _createElementVNode("tbody", _hoisted_179, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFormRolesFilter, (singleRole) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: singleRole.userRoleId
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_180, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              class: "form-check-input",
                                              id: 
                                                'roles_checkbox_' +
                                                singleRole.userRoleId
                                              ,
                                              value: 
                                                singleRole.siteId.toString() +
                                                singleRole.userRoleId.toString()
                                              ,
                                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((
                                                _ctx.post_form_data
                                                  .formRoleGlobalModel.roleIds
                                              ) = $event))
                                            }, null, 8, _hoisted_181), [
                                              [_vModelCheckbox, 
                                                _ctx.post_form_data
                                                  .formRoleGlobalModel.roleIds
                                              ]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_182, [
                                            _createElementVNode("div", _hoisted_183, [
                                              _createElementVNode("span", _hoisted_184, _toDisplayString(singleRole.userRoleName), 1)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", _hoisted_185, _toDisplayString(singleRole.siteName), 1)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_186, [
                      _createElementVNode("h3", _hoisted_187, [
                        _createElementVNode("button", _hoisted_188, [
                          _hoisted_189,
                          _createTextVNode(" " + _toDisplayString(_ctx.t("common.users")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_190, [
                        _createElementVNode("div", _hoisted_191, [
                          _createElementVNode("div", _hoisted_192, [
                            _createElementVNode("div", _hoisted_193, [
                              _createElementVNode("div", _hoisted_194, [
                                _createElementVNode("span", {
                                  class: "svg-icon svg-icon-1 position-absolute ms-3",
                                  onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.filterFormUsers && _ctx.filterFormUsers(...args)))
                                }, _hoisted_196),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "data-kt-user-table-filter": "search",
                                  class: "form-control w-md-350px ps-13",
                                  placeholder: "Search here...",
                                  onKeyup: _cache[43] || (_cache[43] = 
                                    () => {
                                      if (
                                        _ctx.searchTermUsers.length == 0 ||
                                        _ctx.searchTermUsers.length >= 3
                                      )
                                        _ctx.filterFormUsers();
                                    }
                                  ),
                                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.searchTermUsers) = $event))
                                }, null, 544), [
                                  [_vModelText, _ctx.searchTermUsers]
                                ])
                              ])
                            ]),
                            (_ctx.loadingUsers)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                  _createElementVNode("div", _hoisted_198, [
                                    _createElementVNode("span", _hoisted_199, _toDisplayString(_ctx.t("common.loading")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_200, [
                              _createElementVNode("div", _hoisted_201, [
                                _createElementVNode("table", _hoisted_202, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", _hoisted_203, [
                                      _createElementVNode("th", _hoisted_204, [
                                        _createElementVNode("div", _hoisted_205, [
                                          _createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "checkAllUSers",
                                            checked: 
                                              _ctx.allFormUsersFilter.length > 0 &&
                                              _ctx.post_form_data
                                                .formUserGlobalModelDummy
                                                .userIds.length > 0 &&
                                              _ctx.post_form_data
                                                .formUserGlobalModelDummy
                                                .userIds.length ===
                                                _ctx.allFormUsersFilter.length
                                            ,
                                            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.selectAllUsers($event)))
                                          }, null, 8, _hoisted_206)
                                        ])
                                      ]),
                                      _createElementVNode("th", _hoisted_207, _toDisplayString(_ctx.t("common.userName")), 1),
                                      _createElementVNode("th", _hoisted_208, _toDisplayString(_ctx.t("common.email")), 1),
                                      _createElementVNode("th", _hoisted_209, _toDisplayString(_ctx.t("common.siteName")), 1)
                                    ])
                                  ]),
                                  _createElementVNode("tbody", _hoisted_210, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFormUsersFilter, (singleUser) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: singleUser.webId
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_211, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              class: "form-check-input",
                                              value: 
                                                singleUser.siteId.toString() +
                                                singleUser.userRoleId.toString()
                                              ,
                                              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((
                                                _ctx.post_form_data
                                                  .formUserGlobalModelDummy
                                                  .userIds
                                              ) = $event))
                                            }, null, 8, _hoisted_212), [
                                              [_vModelCheckbox, 
                                                _ctx.post_form_data
                                                  .formUserGlobalModelDummy
                                                  .userIds
                                              ]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_213, [
                                            _createElementVNode("div", _hoisted_214, [
                                              _createElementVNode("span", _hoisted_215, _toDisplayString(singleUser.userRoleName), 1)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", _hoisted_216, _toDisplayString(singleUser.email), 1)
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", _hoisted_217, _toDisplayString(singleUser.siteName), 1)
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_218, [
                  _createElementVNode("div", _hoisted_219, [
                    _createElementVNode("h3", _hoisted_220, [
                      _hoisted_221,
                      _createTextVNode(" " + _toDisplayString(_ctx.t("pages.form.events")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_222, [
                      _createElementVNode("div", _hoisted_223, [
                        _createElementVNode("div", _hoisted_224, [
                          _createElementVNode("span", {
                            class: "svg-icon svg-icon-1 position-absolute ms-3",
                            onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.getAllFormEvents && _ctx.getAllFormEvents(...args)))
                          }, _hoisted_226),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "data-kt-user-table-filter": "search",
                            class: "form-control w-md-350px ps-13",
                            placeholder: "Search here...",
                            onKeyup: _cache[48] || (_cache[48] = 
                              () => {
                                if (
                                  _ctx.searchTermEvents.length == 0 ||
                                  _ctx.searchTermEvents.length >= 3
                                )
                                  _ctx.getAllFormEvents();
                              }
                            ),
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.searchTermEvents) = $event))
                          }, null, 544), [
                            [_vModelText, _ctx.searchTermEvents]
                          ])
                        ])
                      ]),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_227, [
                            _createElementVNode("div", _hoisted_228, [
                              _createElementVNode("span", _hoisted_229, _toDisplayString(_ctx.t("common.loading")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_230, [
                        _createElementVNode("div", _hoisted_231, [
                          _createElementVNode("table", _hoisted_232, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_233, [
                                _createElementVNode("th", _hoisted_234, [
                                  _createElementVNode("div", _hoisted_235, [
                                    _createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      sites: "",
                                      id: "checkAllEvents",
                                      checked: 
                                        _ctx.post_form_data.formEventGlobalModel
                                          .eventIds.length > 0 &&
                                        _ctx.allFormEvents.length > 0 &&
                                        _ctx.post_form_data.formEventGlobalModel
                                          .eventIds.length ===
                                          _ctx.allFormEvents.length
                                      ,
                                      onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.selectAllEvents($event)))
                                    }, null, 8, _hoisted_236)
                                  ])
                                ]),
                                _createElementVNode("th", _hoisted_237, _toDisplayString(_ctx.t("pages.event.title")), 1),
                                _createElementVNode("th", _hoisted_238, _toDisplayString(_ctx.t("common.eventMode")), 1)
                              ])
                            ]),
                            _createElementVNode("tbody", _hoisted_239, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFormEvents, (singleEvent) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: singleEvent.webId
                                }, [
                                  (singleEvent.status == 'ACTIVE')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_240, [
                                        _createElementVNode("div", _hoisted_241, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            class: "form-check-input",
                                            value: singleEvent.webId,
                                            id: 
                                          'roles_checkbox_' + singleEvent.webId
                                        ,
                                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((
                                          _ctx.post_form_data.formEventGlobalModel
                                            .eventIds
                                        ) = $event))
                                          }, null, 8, _hoisted_242), [
                                            [_vModelCheckbox, 
                                          _ctx.post_form_data.formEventGlobalModel
                                            .eventIds
                                        ]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (singleEvent.status == 'ACTIVE')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_243, [
                                        _createElementVNode("div", _hoisted_244, [
                                          _createElementVNode("div", _hoisted_245, [
                                            _createElementVNode("span", _hoisted_246, _toDisplayString(singleEvent.eventName), 1)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (singleEvent.status == 'ACTIVE')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_247, [
                                        _createElementVNode("span", _hoisted_248, _toDisplayString(singleEvent.eventSubType
                                        .toLowerCase()
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (c) =>
                                          c.toUpperCase()
                                        )), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_249, [
                  _createElementVNode("div", _hoisted_250, [
                    _createElementVNode("h3", _hoisted_251, [
                      _hoisted_252,
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.preview")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_253, [
                      _createElementVNode("div", _hoisted_254, [
                        _createElementVNode("div", _hoisted_255, [
                          _createElementVNode("table", _hoisted_256, [
                            _createElementVNode("tbody", _hoisted_257, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_258, [
                                  _createElementVNode("div", _hoisted_259, _toDisplayString(_ctx.t("common.name")), 1)
                                ]),
                                _createElementVNode("td", _hoisted_260, [
                                  _createElementVNode("div", _hoisted_261, _toDisplayString(_ctx.post_form_data.name), 1)
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_262, [
                                  _createElementVNode("div", _hoisted_263, _toDisplayString(_ctx.t("common.startDate")), 1)
                                ]),
                                _createElementVNode("td", _hoisted_264, [
                                  _createElementVNode("div", _hoisted_265, _toDisplayString(_ctx.format.convertUTCToLocalDate(
                                        _ctx.post_form_data.startDate
                                      )), 1)
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_266, [
                                  _createElementVNode("div", _hoisted_267, _toDisplayString(_ctx.t("pages.form.category")), 1)
                                ]),
                                _createElementVNode("td", _hoisted_268, [
                                  _createElementVNode("div", _hoisted_269, [
                                    _createElementVNode("div", null, [
                                      (
                                          _ctx.post_form_data.formCategoryGlobalModel
                                            .categoryCode &&
                                          _ctx.post_form_data.formCategoryGlobalModel
                                            .categoryCode.length > 0
                                        )
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_270, _toDisplayString(_ctx.formCategories
                                            .filter((item) =>
                                              _ctx.post_form_data.formCategoryGlobalModel.categoryCode.includes(
                                                item.value
                                              )
                                            )
                                            .map((item) => item.text)
                                            ?.join(", ")), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_271, [
                                  _createElementVNode("div", _hoisted_272, _toDisplayString(_ctx.t("common.otherSelection")), 1)
                                ]),
                                _createElementVNode("td", _hoisted_273, [
                                  _createElementVNode("div", _hoisted_274, [
                                    _createElementVNode("span", _hoisted_275, [
                                      (!_ctx.post_form_data.locationRestrict)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_276))
                                        : (_openBlock(), _createElementBlock("i", _hoisted_277)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.t("pages.user.form.locationRestrict")), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_278, [
                                  _createElementVNode("div", _hoisted_279, _toDisplayString(_ctx.t("common.status")), 1)
                                ]),
                                _createElementVNode("td", _hoisted_280, [
                                  _createElementVNode("div", _hoisted_281, _toDisplayString(_ctx.post_form_data.status.charAt(0) +
                                      _ctx.post_form_data.status
                                        .slice(1)
                                        .toLowerCase()), 1)
                                ])
                              ]),
                              (
                                  _ctx.post_form_data.formSiteGlobalModel.siteIds &&
                                  _ctx.post_form_data.formSiteGlobalModel.siteIds
                                    .length > 0
                                )
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_282, [
                                    _createElementVNode("td", _hoisted_283, [
                                      _createElementVNode("div", _hoisted_284, [
                                        _createElementVNode("h2", _hoisted_285, [
                                          _createElementVNode("button", _hoisted_286, [
                                            _hoisted_287,
                                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.sites")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_288, [
                                          _createElementVNode("div", _hoisted_289, [
                                            _createElementVNode("div", _hoisted_290, [
                                              _createElementVNode("table", _hoisted_291, [
                                                _createElementVNode("thead", null, [
                                                  _createElementVNode("tr", _hoisted_292, [
                                                    _createElementVNode("th", _hoisted_293, _toDisplayString(_ctx.t("common.siteName")), 1),
                                                    _createElementVNode("th", _hoisted_294, _toDisplayString(_ctx.t("pages.site.siteNumber")), 1),
                                                    _createElementVNode("th", _hoisted_295, _toDisplayString(_ctx.t("common.siteAddress")), 1)
                                                  ])
                                                ]),
                                                _createElementVNode("tbody", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFormSites.filter(
                                                  (item) => {
                                                    return _ctx.post_form_data.formSiteGlobalModel.siteIds.includes(
                                                      item.webId
                                                    );
                                                  }
                                                ), (singleSite) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                      key: singleSite.webId
                                                    }, [
                                                      _createElementVNode("td", null, _toDisplayString(singleSite.name), 1),
                                                      _createElementVNode("td", null, _toDisplayString(singleSite.code), 1),
                                                      _createElementVNode("td", _hoisted_296, _toDisplayString(`${singleSite.addressModel.city}, ${singleSite.addressModel.state}, ${singleSite.addressModel.country}`), 1)
                                                    ]))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                                  _ctx.post_form_data.formRoleGlobalModel.roleIds &&
                                  _ctx.post_form_data.formRoleGlobalModel.roleIds
                                    .length > 0
                                )
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_297, [
                                    _createElementVNode("td", _hoisted_298, [
                                      _createElementVNode("div", _hoisted_299, [
                                        _createElementVNode("h2", _hoisted_300, [
                                          _createElementVNode("button", _hoisted_301, [
                                            _hoisted_302,
                                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.roles")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_303, [
                                          _createElementVNode("div", _hoisted_304, [
                                            _createElementVNode("div", _hoisted_305, [
                                              _createElementVNode("table", _hoisted_306, [
                                                _createElementVNode("thead", null, [
                                                  _createElementVNode("tr", _hoisted_307, [
                                                    _createElementVNode("th", _hoisted_308, _toDisplayString(_ctx.t("pages.user.roleName")), 1),
                                                    _createElementVNode("th", _hoisted_309, _toDisplayString(_ctx.t("common.siteName")), 1)
                                                  ])
                                                ]),
                                                _createElementVNode("tbody", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFormRolesFilter.filter(
                                                  (item) => {
                                                    return _ctx.post_form_data.formRoleGlobalModel.roleIds.includes(
                                                      item.siteId.toString() +
                                                        item.userRoleId.toString()
                                                    );
                                                  }
                                                ), (singleRole) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                      key: singleRole.userRoleId
                                                    }, [
                                                      _createElementVNode("td", null, _toDisplayString(singleRole.userRoleName), 1),
                                                      _createElementVNode("td", null, _toDisplayString(singleRole.siteName), 1)
                                                    ]))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                                  _ctx.post_form_data.formUserGlobalModelDummy
                                    .userIds &&
                                  _ctx.post_form_data.formUserGlobalModelDummy
                                    .userIds.length > 0
                                )
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_310, [
                                    _createElementVNode("td", _hoisted_311, [
                                      _createElementVNode("div", _hoisted_312, [
                                        _createElementVNode("h2", _hoisted_313, [
                                          _createElementVNode("button", _hoisted_314, [
                                            _hoisted_315,
                                            _createTextVNode(" " + _toDisplayString(_ctx.t("pages.user.title")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_316, [
                                          _createElementVNode("div", _hoisted_317, [
                                            _createElementVNode("div", _hoisted_318, [
                                              _createElementVNode("table", _hoisted_319, [
                                                _createElementVNode("thead", null, [
                                                  _createElementVNode("tr", _hoisted_320, [
                                                    _createElementVNode("th", _hoisted_321, _toDisplayString(_ctx.t("common.name")), 1),
                                                    _createElementVNode("th", _hoisted_322, _toDisplayString(_ctx.t("common.email")), 1),
                                                    _createElementVNode("th", _hoisted_323, _toDisplayString(_ctx.t("common.siteName")), 1)
                                                  ])
                                                ]),
                                                _createElementVNode("tbody", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFormUsersFilter.filter(
                                                  (item) => {
                                                    return _ctx.post_form_data.formUserGlobalModelDummy.userIds.includes(
                                                      item.siteId.toString() +
                                                        item.userRoleId.toString()
                                                    );
                                                  }
                                                ), (singleUser) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                      key: singleUser.userRoleId
                                                    }, [
                                                      _createElementVNode("td", null, _toDisplayString(singleUser.userRoleName), 1),
                                                      _createElementVNode("td", null, _toDisplayString(singleUser.email), 1),
                                                      _createElementVNode("td", null, _toDisplayString(singleUser.siteName), 1)
                                                    ]))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (
                                  _ctx.post_form_data.formEventGlobalModel
                                    .eventIds &&
                                  _ctx.post_form_data.formEventGlobalModel.eventIds
                                    .length > 0
                                )
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_324, [
                                    _createElementVNode("td", _hoisted_325, [
                                      _createElementVNode("div", _hoisted_326, [
                                        _createElementVNode("h2", _hoisted_327, [
                                          _createElementVNode("button", _hoisted_328, [
                                            _hoisted_329,
                                            _createTextVNode(" " + _toDisplayString(_ctx.t("pages.form.events")), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_330, [
                                          _createElementVNode("div", _hoisted_331, [
                                            _createElementVNode("div", _hoisted_332, [
                                              _createElementVNode("table", _hoisted_333, [
                                                _createElementVNode("thead", null, [
                                                  _createElementVNode("tr", _hoisted_334, [
                                                    _createElementVNode("th", _hoisted_335, _toDisplayString(_ctx.t("pages.event.title")), 1),
                                                    _createElementVNode("th", _hoisted_336, _toDisplayString(_ctx.t("common.eventMode")), 1)
                                                  ])
                                                ]),
                                                _createElementVNode("tbody", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFormEvents.filter(
                                                  (item) => {
                                                    return _ctx.post_form_data.formEventGlobalModel.eventIds.includes(
                                                      item.webId
                                                    );
                                                  }
                                                ), (singleEvent) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                      key: singleEvent.webId
                                                    }, [
                                                      _createElementVNode("td", null, _toDisplayString(singleEvent.eventName), 1),
                                                      _createElementVNode("td", _hoisted_337, _toDisplayString(singleEvent.eventSubType
                                                        .toLowerCase()
                                                        .replace(/_/g, " ")
                                                        .replace(/\b\w/g, (c) =>
                                                          c.toUpperCase()
                                                        )), 1)
                                                    ]))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_338, [
            (_ctx.currentStepIndex > 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  "data-kt-stepper-action": "previous",
                  onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.previousStep()))
                }, [
                  _createElementVNode("span", _hoisted_339, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _hoisted_340
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.closeModal()))
                }, [
                  _createElementVNode("span", _hoisted_341, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _hoisted_342
                ])),
            (_ctx.currentStepIndex == 6)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "submit",
                  ref: "submitButton",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)))
                }, [
                  _createElementVNode("span", _hoisted_343, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.save")) + " ", 1),
                    _createElementVNode("span", _hoisted_344, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]),
                  _hoisted_345
                ], 512))
              : (_openBlock(), _createElementBlock("button", _hoisted_346, [
                  _hoisted_347,
                  _createElementVNode("span", _hoisted_348, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]))
          ])
        ])
      ], 32)
    ]),
    _createVNode(_component_FormSectionModal, {
      viewName: "form_section_modal",
      data: _ctx.selectedSection,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[56] || (_cache[56] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "showDialog"]),
    _createVNode(_component_AddEditModal, {
      viewName: "add_edit_form_section_location_modal",
      modelValue: _ctx.showAddLocationModal,
      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.showAddLocationModal) = $event)),
      data: _ctx.computedUserSiteModalData,
      onClose: _cache[58] || (_cache[58] = ($event: any) => (_ctx.showAddLocationModal = false)),
      onOnSubmit: _ctx.submitSiteRole,
      onOnCancel: _cache[59] || (_cache[59] = ($event: any) => (_ctx.showAddLocationModal = false)),
      onOnSiteChange: _ctx.handleSiteChange
    }, null, 8, ["modelValue", "data", "onOnSubmit", "onOnSiteChange"])
  ], 512))
}